import slang from "../../assets/clients/slang.svg";
import open from "../../assets/clients/open-vape.png";
import bakked from "../../assets/clients/bakked-extracts.svg";
import ceres from "../../assets/clients/ceres-med-vt.png";
import district from "../../assets/clients/district-edibles.png";
import alchemy from "../../assets/clients/alchemy-naturals-cbd.png";
import blackbarnapiary from "../../assets/clients/Black-Barn-Apiary.svg";
import firefly from "../../assets/clients/firefly-vapor-w.png";
import elevate from "../../assets/clients/elevate-pet.png"
import superspeciosa from "../../assets/clients/super-speciosa.png"
import royo from "../../assets/clients/royo-bread-co.png"

import wildsociety from "../../assets/clients/ws-logo-w.png";
import longplay from "../../assets/clients/longplay-wellness-w.png";
import greendragon from "../../assets/clients/green-dragon-white.webp";

import Marquee from "../../lib/marquee";

function ClientMarquee() {
  return (
    <div className="client-block container mx-auto">
      <Marquee
        pauseOnClick={false}
        // gradient="true"
        // gradientColor="rgba(17,24,27,0.1)"
        autoFill={true}
        direction="right"
        speed={29}
        style={{
          color: "var(--primary)",
          fontSize: "0.9rem",
          textTransform: "uppercase",
          fontFamily: "var(--font-primary)",
        }}
      >
        <img src={open} className="client-logos" />
        <img src={blackbarnapiary} className="client-logos" />
        <img src={superspeciosa} className="client-logos" />
        <img src={royo} className="client-logos" />
        <img src={firefly} className="client-logos" />
        <img src={ceres} className="client-logos" />
        <img src={alchemy} className="client-logos" />
        <img src={slang} className="client-logos" />
        <img src={bakked} className="client-logos" />
        <img src={district} className="client-logos" />
        <img src={elevate} className="client-logos" />
        <img src={wildsociety} className="client-logos" />
        <img src={longplay} className="client-logos" />
        <img src={greendragon} className="client-logos" />
      </Marquee>
    </div>
  );
}

export default ClientMarquee;
